const enum ComponentNames {
  AssignedTo = 'AssignedTo',
  AddOrdersButton = 'AddOrdersButton',
  Checkout = 'Checkout',
  Countdown = 'Countdown',
  CompanySettings = 'CompanySettings',
  CustomerNotificationsTab = 'CustomerNotificationsTab',
  CreateTokenButton = 'CreateTokenButton',
  DrawRouteBar = 'DrawRouteBar',
  DebugFrame = 'DebugFrame',
  DebugOrganizationModal = 'DebugOrganizationModal',
  DebugOrganizationConfirmationModal = 'DebugOrganizationConfirmationModal',
  DetailsPanel = 'DetailsPanel',
  DraggableVisitsLayer = 'DraggableVisitsLayer',
  DriverListing = 'DriverListing',
  DeleteDriver = 'DeleteDriver',
  DownloadCSV = 'DownloadCSV',
  HeaderButtonBar = 'HeaderButtonBar',
  MainMenu = 'MainMenu',
  NavigationMenu = 'NavigationMenu',
  OrderDetailsPanel = 'OrderDetailsPanel',
  OrdersScheduleButton = 'OrdersScheduleButton',
  OptimizationPreferences = 'OptimizationPreferences',
  PendingInviteBanner = 'PendingInviteBanner',
  PublishButton = 'PublishButton',
  UnpublishButton = 'UnpublishButton',
  QuickAddButton = 'QuickAddButton',
  RouteDetailsPanel = 'RouteDetailsPanel',
  RouteGanttGroupInner = 'RouteGanttGroupInner',
  RoutesMultiSelectActionBar = 'RoutesMultiSelectActionBar',
  RoutesEmptyState = 'RoutesEmptyState',
  RoutesPanel = 'RoutesPanel',
  RouteSummary = 'RouteSummary',
  RoutesTable = 'RoutesTable',
  RevokeTokenButton = 'RevokeTokenButton',
  RouteTemplates = 'RouteTemplates',
  SchedulingContentDesktop = 'SchedulingContentDesktop',
  ScheduledTo = 'ScheduledTo',
  StandardRouteCard = 'StandardRouteCard',
  TimelineCard = 'TimelineCard',
  UnscheduledVisitsPanel = 'UnscheduledVisitsPanel',
  UnscheduledVisitsTable = 'UnscheduledVisitsTable',
  UseMenuItems = 'UseMenuItems',
  UpgradeButton = 'UpgradeButton',
  CancelSubscriptionButton = 'CancelSubscriptionButton',
  CustomerProfilesTable = 'CustomerProfilesTable',
  ViewMenu = 'ViewMenu',
  VisitsMultiSelectActionBar = 'VisitsMultiSelectActionBar',
  Workspace = 'Workspace',
  WorkspaceSettings = 'WorkspaceSettings',
  WorkspaceSettingsTab = 'WorkspaceSettingsTab',
  ShopifySettingsTab = 'ShopifySettingsTab',
  WebhooksTab = 'WebhooksTab',
  TeamSettingsTab = 'TeamSettingsTab',
  OpenPanelButton = 'OpenPanelButton',
}

export default ComponentNames;
